import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 24px;
`;

export const ImageContainer = styled(Flex)`
  position: relative;
  width: 64px;
  height: 48px;
  background-size: cover;
  background-position: center;
  .ant-image {
    width: 100%;
    height: 100% !important;
  }
  .ant-image-img {
    width: 100%;
    height: 100% !important;
    object-fit: cover;
    object-position: 50% 50%;
  }
`;

export const ActionButtonWrapper = styled.div`
  padding: 8px;
  color: #999b9e;
  &:hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
